import type { Locale } from "./i18n/locale";

/** The region each language's dates are written for. */
const DATE_LOCALE: Record<Locale, string> = { ja: "ja-JP", en: "en-US" };

/**
 * How a timestamp reads. Shared so the list and the detail agree: the bare
 * locale string gives `2026/9/15 6:30:06` on one screen and a zero-padded
 * value on the other, which reads like two different records.
 */
export function formatTimestamp(iso: string, locale: Locale): string {
  return new Date(iso).toLocaleString(DATE_LOCALE[locale], {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
